import { render, staticRenderFns } from "./OptionGroups.vue?vue&type=template&id=a583e516&scoped=true&"
import script from "./OptionGroups.vue?vue&type=script&lang=ts&"
export * from "./OptionGroups.vue?vue&type=script&lang=ts&"
import style0 from "./OptionGroups.vue?vue&type=style&index=0&id=a583e516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a583e516",
  null
  
)

export default component.exports